import { render, staticRenderFns } from "./ringReport.vue?vue&type=template&id=0ed36574&scoped=true&"
import script from "./ringReport.vue?vue&type=script&lang=js&"
export * from "./ringReport.vue?vue&type=script&lang=js&"
import style0 from "./ringReport.vue?vue&type=style&index=0&id=0ed36574&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed36574",
  null
  
)

export default component.exports